<template>
  <div>
    <v-container>
      <v-card v-if="!contatoSalvo">
        <div class="text-center">
					<v-sheet color="white" class="pt-5 pb-5">
						<img src="@/assets/img/logo.svg" alt="CETABA" height="120" />
					</v-sheet>
				</div>
        <v-card-title>
          <span class="headline">Cadastro gratuito para palestras</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" md="6" lg="3">
                <v-text-field v-model="pessoa.nome" label="Nome*" :rules="[rules.required, rules.min2]"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-text-field v-model="pessoa.cpf" label="Cpf*" :rules="[rules.required, rules.cpf]" v-mask="'###.###.###-##'" ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-text-field v-model="contato.email" label="E-mail*" :rules="[rules.required, rules.email]"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-text-field v-model="contato.telefone" label="Telefone*" :rules="[rules.required]" v-mask="['(##) ####-####', '(##) #####-####']"></v-text-field>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col cols="12" md="6">
                <v-textarea v-model="pessoa.endereco" label="Endereço completo" rows="2"></v-textarea>
              </v-col>
              <v-col cols="12" md="6">
                <v-textarea v-model="pessoa.obs" label="Obsesrvação" rows="2"></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <v-autocomplete
                  v-model="empresaSelected"
                  :items="empresaList"
                  item-text="nome_fantasia"
                  item-value="id"
                  label="Empresa"
                  placeholder="Selecione uma empresa"
                  return-object
                  id="nome_fantasia"
                >
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ data.item.nome_fantasia }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
                <v-chip class="ma-2" small @click="dialogShow=true,sujestaoEmpresa=true" color="default">
                  Não encontrou sua empresa?
                </v-chip>
              </v-col>
              <v-col cols="12" sm="6">
                <v-autocomplete
                  v-model="cargoSelected"
                  :items="cargoList"
                  item-text="cargo"
                  item-value="id"
                  label="Cargo"
                  placeholder="Selecione um cargo"
                  return-object
                  id="cargo"
                >
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ data.item.cargo }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
                <v-chip class="ma-2" small @click="dialogShow=true,sujestaoCargo=true" color="default">
                  Não encontrou seu cargo?
                </v-chip>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <p>Adicione os cursos e periodo caso já tenha participado <br>
                <small>Caso já tenha participado de mais de um curso, clique em adicionar novamente</small>
                </p>
              </v-col>
              <v-col cols="12">
                <v-btn dark color="primary" @click="addPeriodo()" title="Adicionar periodo" class="mb-2 mr-2">
                  <v-icon left>mdi-plus</v-icon> Adicionar curso com periodo
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <Periodo 
                v-for="(compPeriodo, i) in compPeriodos" :key="i" 
                :ref="'compPeriodo'+i"
                :id="'compPeriodo'+i"
                :compPeriodoId="compPeriodo.compPeriodoId"
                :compPeriodoIndex="i"
                :periodosList="periodosList"
                @peridoSelected="peridoSelected"
              />
              <v-col cols="12">
                <v-btn v-if="compPeriodos.length>0" color="blue-grey lighten-5" @click="removePeriodo()" title="Remover periodo" class="mb-2">
                  <v-icon left>mdi-delete</v-icon> Remover curso com periodo
                </v-btn>
              </v-col>
            </v-row>

          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" dark @click="save"><v-icon left>fas fa-save</v-icon> Salvar e enviar</v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="contatoSalvo" color="success" dark>
        <div class="text-center">
					<v-sheet color="white" class="pt-5 pb-4">
						<img src="@/assets/img/logo.svg" alt="CETABA" height="150" />
					</v-sheet>
				</div>
        <v-card-text class="text-center">
          <h1 class="mb-6">Cadastro realizado com sucesso!</h1>
          <h3>Muito obrigado por fazer parte da nossa história</h3>
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog v-model="dialogShow" max-width="800px">
      <v-card>
        <v-card-title>
          <p class="title">Não encontrou sua empresa ou seu cargo?</p>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogShow=false" icon ><v-icon>fal fa-times</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <p class="subtitle-1">Escreva uma sujestão e iremos verificar a possibilidade de inserção em nosso sistema!</p>
        </v-card-text>
        <v-card-text v-if="!sujestaoSalvo">
          <v-form ref="form2">
            <v-row>
              <v-col cols="12" sm="6">
                <v-checkbox
                  v-model="sujestaoEmpresa"
                  label="Sujestão de empresa"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6">
                <v-checkbox
                  v-model="sujestaoCargo"
                  label="Sujestão de cargo"
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="sujestao" label="Escreva sua sujestão" :rules="[rules.required]"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-text v-else >
          <h2 class="green--text">
            Sujestão cadastrada com sucesso :)
          </h2>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" dark @click="saveSujestao()" v-if="!sujestaoSalvo"><v-icon left>fas fa-save</v-icon> Salvar e enviar</v-btn>
          <v-btn color="primary blue-1" dark @click="sujestaoSalvo=false" v-else><v-icon left>fas fa-arrow-left</v-icon> Cadastrar outra sujestão</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

	</div>
</template>

<script>
import { mapState } from 'vuex'
import Periodo from '@/components/Periodo'

export default {
  components: {
		Periodo,
	},
	data () {
    return {
      dialogShow: false,
      compPeriodoCont: 0,
      compPeriodos: [],
			pessoa: {
        id: '',
				nome: '',
				cpf: '',
				endereco: '',
				obs: '',
      },
      contato: {
				email: '',
				telefone: '',
      },
      periodosList: [],
      peridosSelected: [],
      contatoSalvo: false,
      
      empresaList: [],
      empresaSelected: null,
      cargoList: [],
      cargoSelected: null,

      sujestao: null,
      sujestaoSalvo: false,
      sujestaoEmpresa: true,
      sujestaoCargo: false,
      sujestoesCadastradas: []
		}
  },
  computed: {
    ...mapState(
      ['rules']
    ),
  },
  created() {
    this.getDadosSelects();
  },
  watch: {
    sujestaoEmpresa(val) { this.sujestaoCargo = !val },
		sujestaoCargo(val) { this.sujestaoEmpresa = !val },
  },
  methods: {
    addPeriodo() {
			this.compPeriodoCont++
			this.compPeriodos.push({ compPeriodoId: this.compPeriodoCont })
		},
    removePeriodo() {
			this.compPeriodos.pop()
		},
    peridoSelected(val){
      this.compPeriodos.filter(f => f.compPeriodoId == val.compPeriodoId )[0].peridoSelected = val.peridoSelected
    },
    getDadosSelects(){
      let formData = new FormData()
      formData.append('frase', 'Cadastro pelo cliente')
      formData.append('function', 'selects')
      let vd = this
      this.$axiosPost.post('cadastro/user.php', formData)
			.then(function (response) {
        if(response.data.error === 0){
          vd.periodosList = response.data.periodos
          vd.empresaList = response.data.empresas
          vd.cargoList = response.data.cargos
        }else{
          vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
        }
			}).catch(function(response){
        console.log('ERRO!! '+response);
      })
    },

    save(){
      if(this.$refs.form.validate()){
        let formData = new FormData()
        formData.append('frase', 'Cadastro pelo cliente')
        formData.append('function', 'pessoa')
        Object.entries(this.pessoa).forEach(([key, value]) => {
          formData.append(key, value)
        })
        let vd = this
        this.$axiosPost.post('cadastro/user.php', formData)
        .then(function (response) {
          if(response.data.error === 0){
            vd.pessoa.id = response.data.id
            vd.contatoSalvo = true
            vd.saveContato()
            vd.saveEmpresaCargo()
            Object.entries(vd.sujestoesCadastradas).forEach(([key, value]) => {
              vd.updateSujestao(vd.pessoa.id, value)
            })
          }else{
            vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
          }
        }).catch(function(response){
          console.log('ERRO!! '+response);
        })
      }
    },
    saveContato(){
      let formData = new FormData()
      formData.append('frase', 'Cadastro pelo cliente')
      formData.append('function', 'contato')
      Object.entries(this.contato).forEach(([key, value]) => {
        formData.append(key, value)
      })
      formData.set('pessoa_id', this.pessoa.id)
      let vd = this
      this.$axiosPost.post('cadastro/user.php', formData)
      .then(function (response) {
        console.log(response.data.alertMessage);
        Object.entries(vd.compPeriodos).forEach(([key, value]) => {
          vd.savePeriodoCurso(value)
        })
      }).catch(function(response){
        console.log('ERRO!! '+response);
      })
    },
    savePeriodoCurso(value){
      let formData = new FormData()
      formData.append('frase', 'Cadastro pelo cliente')
      formData.append('function', 'periodo')
      formData.append('pessoa_id', this.pessoa.id)
      formData.append('periodo_id', value.peridoSelected)
      this.$axiosPost.post('cadastro/user.php', formData)
      .then(function (response) {
        console.log(response.data.alertMessage);
      }).catch(function(response){
        console.log('ERRO!! '+response);
      })
    },
    saveEmpresaCargo(){
      if(this.empresaSelected!=null&&this.cargoSelected!=null){
        if(this.$refs.form.validate()){
          let formData = new FormData()
          formData.append('frase', 'Cadastro pelo cliente')
          formData.append('function', 'pessoa_empresas')
          formData.append('cpf', this.pessoa.cpf)
          formData.append('pessoa_id', this.pessoa.id)
          formData.append('empresa_id', this.empresaSelected.id)
          formData.append('cargo_id', this.cargoSelected.id)
          this.$axiosPost.post('cadastro/empresa.php', formData)
          .then(function (response) {
            console.log(response.data.alertMessage);
          }).catch(function(response){
            console.log('ERRO!! '+response);
          })
      }
      }
    },

    saveSujestao(){
      if(this.$refs.form2.validate()){
        let formData = new FormData()
        formData.append('frase', 'Cadastro pelo cliente')
        formData.append('function', 'sujestao')
        formData.append('pessoa_id', null)
        formData.append('empresa', this.sujestaoEmpresa?1:0)
        formData.append('cargo', this.sujestaoCargo?1:0)
        formData.append('sujestao', this.sujestao)
        let vd = this
        this.$axiosPost.post('cadastro/empresa.php', formData)
        .then(function (response) {
          if(response.data.error === 0){
            vd.sujestoesCadastradas.push(response.data.id)
            vd.sujestaoSalvo = true
            vd.sujestao = null
          }else{
            vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
          }
        }).catch(function(response){
          console.log('ERRO!! '+response);
        })
      }
    },

    updateSujestao(pessoa_id, sujestao_id){
      let formData = new FormData()
      formData.append('frase', 'Cadastro pelo cliente')
      formData.append('function', 'sujestao_pessoa_id')
      formData.append('pessoa_id', pessoa_id)
      formData.append('sujestao_id', sujestao_id)
      let vd = this
      this.$axiosPost.post('cadastro/empresa.php', formData)
      .then(function (response) {
        if(response.data.error === 0){
          console.log(response.data.alertMessage);
        }else{
          vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
        }
      }).catch(function(response){
        console.log('ERRO!! '+response);
      })
    },

  },
}
</script>